import type { RulesetPoints } from "./rulesets";

export type StatLine = Readonly<{
  hits: number;
  doubles: number;
  triples: number;
  homeRuns: number;
  rbi: number;
  runs: number;
  walks: number;
  stolenBases: number;
  caughtStealing: number;
  strikeouts: number;
}>;

export type ScoringResult = Readonly<{
  singles: number;
  fantasyPoints: number;
}>;

/**
 * Pure scoring function. Caller supplies the live `points` (loaded once from
 * the `scoringRules` table via `loadHitterRules`) — never accept fantasyPoints
 * from a client.
 */
export function computePoints(stats: StatLine, points: RulesetPoints): ScoringResult {
  const singles = Math.max(0, stats.hits - stats.doubles - stats.triples - stats.homeRuns);

  const fantasyPoints =
    singles * points.single +
    stats.doubles * points.double +
    stats.triples * points.triple +
    stats.homeRuns * points.homeRun +
    stats.rbi * points.rbi +
    stats.runs * points.run +
    stats.walks * points.walk +
    stats.stolenBases * points.stolenBase +
    stats.caughtStealing * points.caughtStealing +
    stats.strikeouts * points.strikeout;

  return { singles, fantasyPoints };
}
